import React, { useEffect, useState } from "react";
import { SyncLoader } from "react-spinners";
import "../../styles/utils/StoryImage.scss";
import useAppTranslation from "../../hooks/useAppTranslation";

const StoryImage = ({ src, alt }) => {
  const { t } = useAppTranslation("components/utils/listLoading");
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    setIsImageLoaded(false);
  }, [src]);

  const handleImageLoad = () => {
    setTimeout(() => {
      setIsImageLoaded(true);
    }, 100);
  };

  return (
    <figure className="stories-bg">
      {!isImageLoaded && (
        <div className="spinner-container">
          <figure>
            <img
              src="/images/utils/loading/nikiariel.svg"
              alt={t("imageAlt")}
              loading="lazy"
              decoding="async"
            />
          </figure>
          <div className="spinner">
            {t("message")}
            <SyncLoader size={3} />
          </div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
        className={isImageLoaded ? "loaded" : ""}
        style={{
          opacity: isImageLoaded ? 1 : 0.8,
          transition: "opacity 0.5s ease-in-out",
        }}
        loading="lazy"
        decoding="async"
      />
    </figure>
  );
};

export default StoryImage;
